import { motion } from "framer-motion";
import { COMPANY } from "@/lib/siteData";

export const WhatsAppButton = () => {
  return (
    <motion.a
      data-testid="whatsapp-button"
      href={COMPANY.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      initial={{ opacity: 0, scale: 0, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.4, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.94 }}
      className="fixed bottom-5 left-5 z-50 flex items-center gap-3 rounded-full bg-[#25D366] pl-4 pr-5 py-3 shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)] group"
    >
      <span className="relative flex h-6 w-6 items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white/40 opacity-75 animate-ping" />
        <svg viewBox="0 0 32 32" className="relative h-6 w-6 fill-white" aria-hidden="true">
          <path d="M16.004 2.667C8.64 2.667 2.67 8.637 2.67 16c0 2.35.616 4.646 1.787 6.67L2.667 29.333l6.83-1.79A13.27 13.27 0 0 0 16.004 29.3c7.36 0 13.33-5.97 13.33-13.33S23.363 2.667 16.004 2.667zm0 24.03a10.66 10.66 0 0 1-5.43-1.487l-.39-.23-4.053 1.063 1.08-3.95-.253-.406A10.63 10.63 0 0 1 5.34 16c0-5.88 4.784-10.663 10.664-10.663 2.848 0 5.525 1.11 7.54 3.124a10.6 10.6 0 0 1 3.12 7.543c0 5.88-4.783 10.693-10.66 10.693zm6.05-7.98c-.33-.166-1.96-.966-2.264-1.076-.303-.11-.524-.166-.746.166-.22.33-.855 1.076-1.048 1.297-.193.22-.386.248-.717.083-.33-.166-1.4-.516-2.667-1.646-.986-.88-1.652-1.966-1.845-2.296-.193-.33-.02-.51.145-.674.15-.148.33-.386.496-.58.166-.193.22-.33.33-.55.11-.22.055-.414-.028-.58-.083-.166-.746-1.797-1.022-2.46-.27-.646-.543-.558-.746-.568l-.635-.011c-.22 0-.58.083-.883.414-.303.33-1.16 1.132-1.16 2.763s1.187 3.206 1.353 3.427c.166.22 2.336 3.567 5.66 5.002.79.34 1.407.544 1.888.696.793.252 1.515.216 2.086.131.636-.095 1.96-.8 2.236-1.573.276-.773.276-1.436.193-1.573-.083-.138-.303-.22-.635-.386z" />
        </svg>
      </span>
      <span className="text-sm font-semibold text-white pr-0.5">Chat on WhatsApp</span>
    </motion.a>
  );
};
